export enum DataSource {
    AllDevices = 'all',
    Update = 'update',
}